export default "__VITE_ASSET__92255a06__"